"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageDecimalField = void 0;
var _ManageNumericField2 = require("./ManageNumericField");
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Extends ManageNumericField to handle positive and negative decimal numbers
 * 
 * All the same props for ManageNumericField are available, with the addition of optional:
 * 
 *     decimalPlaces:  number of places to show (default = 0)
 * 
 */
var ManageDecimalField = exports.ManageDecimalField = /*#__PURE__*/function (_ManageNumericField) {
  function ManageDecimalField(props) {
    var _this;
    _classCallCheck(this, ManageDecimalField);
    _this = _callSuper(this, ManageDecimalField, [props]);
    _this.state.text = _this.stringForVal(props.initialValue);
    _this._initialText = _this.stringForVal(props.initialValue);
    return _this;
  }

  //Override!   
  _inherits(ManageDecimalField, _ManageNumericField);
  return _createClass(ManageDecimalField, [{
    key: "parseText",
    value: function parseText(text) {
      return parseFloat(text);
    }

    //Override!       
  }, {
    key: "interpretVal",
    value: function interpretVal(text) {
      if (text === null || text === undefined) {
        if (this._hasInfinity) {
          return "Unlimited";
        } else return 0;
      }
      var newDecimal = this.parseText(text);
      if (this.props.minValue != null && newDecimal < this.props.minValue) newDecimal = parseFloat(this.props.minValue);
      if (this.props.maxValue != null && newDecimal > this.props.maxValue) newDecimal = parseFloat(this.props.maxValue);
      return newDecimal.toFixed(this.props.decimalPlaces ? this.props.decimalPlaces : 0);
    }
  }]);
}(_ManageNumericField2.ManageNumericField);